import * as React from 'react';

import { useTranslations } from '../../../i18n/useTranslations';
import { KeyValueEditor, JsonTemplateEditor } from '../../editor/shared';

export type HttpWebhookTestPayload = {
  headers: Record<string, string>;
  query: Record<string, string>;
  body: string;
};

type HttpWebhookTestFormProps = {
  value: HttpWebhookTestPayload;
  onChange: (value: HttpWebhookTestPayload) => void;
};

export const HttpWebhookTestForm: React.FC<HttpWebhookTestFormProps> = ({
  value,
  onChange,
}) => {
  const t = useTranslations();

  const handleHeadersChange = React.useCallback(
    (headers: Record<string, string>) => {
      onChange({ ...value, headers });
    },
    [value, onChange],
  );

  const handleQueryChange = React.useCallback(
    (query: Record<string, string>) => {
      onChange({ ...value, query });
    },
    [value, onChange],
  );

  const handleBodyChange = React.useCallback(
    (body: string) => {
      onChange({ ...value, body });
    },
    [value, onChange],
  );

  return (
    <div className="@HttpWebhookTestForm space-y-6">
      <KeyValueEditor
        label={t.dialogs.test.httpWebhook.headers}
        description={t.dialogs.test.httpWebhook.headersDescription}
        value={value.headers}
        onChange={handleHeadersChange}
        keyPlaceholder={t.dialogs.test.httpWebhook.headerKeyPlaceholder}
        valuePlaceholder={t.dialogs.test.httpWebhook.headerValuePlaceholder}
      />

      <KeyValueEditor
        label={t.dialogs.test.httpWebhook.queryParams}
        description={t.dialogs.test.httpWebhook.queryParamsDescription}
        value={value.query}
        onChange={handleQueryChange}
        keyPlaceholder={t.dialogs.test.httpWebhook.queryKeyPlaceholder}
        valuePlaceholder={t.dialogs.test.httpWebhook.queryValuePlaceholder}
      />

      <JsonTemplateEditor
        label={t.dialogs.test.httpWebhook.body}
        description={t.dialogs.test.httpWebhook.bodyDescription}
        value={value.body}
        onChange={handleBodyChange}
        placeholder='{"key": "value"}'
        rows={6}
      />
    </div>
  );
};

export const defaultHttpWebhookTestPayload: HttpWebhookTestPayload = {
  headers: {},
  query: {},
  body: '{}',
};
